import BaseService from './base'

export default class QuestionService extends BaseService {
  static resource() {
    return 'api/v1/questions'
  }
}
